import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

/**
 * Custom preloading strategy for routes
 * 
 * Preloads routes marked with data.preload = true after initial load
 * Uses a delay to ensure critical routes load first
 * 
 * Usage in route config:
 * {
 *   path: 'dashboard',
 *   loadComponent: () => import('...'),
 *   data: { preload: true, delay: 2000 }
 * }
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Check if route should be preloaded
    if (route.data && route.data['preload']) {
      const delay = route.data['delay'] || 0;
      
      // Preload after delay
      if (delay > 0) {
        return timer(delay).pipe(
          mergeMap(() => {
            console.log('Preloading route:', route.path);
            return load();
          })
        );
      }
      
      // Preload immediately
      console.log('Preloading route:', route.path);
      return load();
    }
    
    // Don't preload
    return of(null);
  }
}
